export enum TeamingLogMessages {
  HANDOFF_BUTTON_CLICKED = 'Handoff button clicked',
}
